"use client";

import { c as _c } from "react/compiler-runtime";
import { Check } from "@icon-park/svg";
import clsx from "clsx";
import { ChangeEventHandler, FocusEventHandler, PropsWithChildren, forwardRef } from "react";
import Icon from "../Icon";
export interface RadioCardProps {
  name?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: ChangeEventHandler;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  "aria-invalid"?: boolean;
  type: "checkbox" | "radio";
  className?: string;
  value: string;
  icon?: React.ReactNode;
  size?: "xs" | "sm" | "md";
  disabled?: boolean;
}
const RadioCard = forwardRef<HTMLInputElement, PropsWithChildren<RadioCardProps>>(function RadioCard(t0, ref) {
  const $ = _c(74);
  const {
    name,
    value,
    type,
    size: t1,
    defaultChecked,
    checked,
    onChange,
    onBlur,
    "aria-invalid": ariaInvalid,
    className,
    children,
    disabled,
    icon
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const isCheckbox = type === "checkbox";
  const t2 = `${name}-${value}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.toLocaleLowerCase();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !disabled;
  let t5;
  if ($[2] !== className || $[3] !== disabled || $[4] !== t4) {
    t5 = clsx("flex w-full text-app-body-2 relative group/switch", className, {
      "cursor-pointer": t4,
      "cursor-not-allowed": disabled
    });
    $[2] = className;
    $[3] = disabled;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== ariaInvalid || $[7] !== checked || $[8] !== defaultChecked || $[9] !== disabled || $[10] !== name || $[11] !== onBlur || $[12] !== onChange || $[13] !== ref || $[14] !== type || $[15] !== value) {
    t6 = <input disabled={disabled} onChange={onChange} onBlur={onBlur} aria-invalid={ariaInvalid} name={name} value={value} ref={ref} type={type} defaultChecked={defaultChecked} checked={checked} className="h-none w-none absolute overflow-hidden opacity-0 peer" />;
    $[6] = ariaInvalid;
    $[7] = checked;
    $[8] = defaultChecked;
    $[9] = disabled;
    $[10] = name;
    $[11] = onBlur;
    $[12] = onChange;
    $[13] = ref;
    $[14] = type;
    $[15] = value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = isCheckbox ? "rounded-xs" : "rounded-full";
  const t8 = !icon && size === "md";
  const t9 = !icon && size === "sm";
  const t10 = !icon && size === "xs";
  const t11 = icon && size === "md";
  const t12 = icon && size === "sm";
  const t13 = icon && size === "xs";
  const t14 = !disabled;
  let t15;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t13 || $[21] !== t14 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t15 = clsx("bg-neutral-0 w-2s h-2s border border-neutral-150 peer-checked:hidden absolute top-1/2 -translate-y-1/2", t7, {
      "left-3s w-2s h-2s": t8,
      "left-s w-2s h-2s": t9,
      "left-3xs w-s h-s": t10,
      "right-3s w-2s h-2s": t11,
      "right-s w-2s h-2s": t12,
      "right-3xs w-s h-s": t13,
      "group-hover/switch:border-primary-800 group-active/switch:border-primary-875": t14
    });
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15) {
    t16 = <span className={t15} />;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = isCheckbox ? "rounded-xs bg-current" : "rounded-full bg-neutral-0";
  const t18 = !icon && size === "md";
  const t19 = !icon && size === "sm";
  const t20 = !icon && size === "xs";
  const t21 = icon && size === "md";
  const t22 = icon && size === "sm";
  const t23 = icon && size === "xs";
  const t24 = !disabled;
  let t25;
  if ($[28] !== disabled || $[29] !== t17 || $[30] !== t18 || $[31] !== t19 || $[32] !== t20 || $[33] !== t21 || $[34] !== t22 || $[35] !== t23 || $[36] !== t24) {
    t25 = clsx("hidden w-2s h-2s border border-current peer-checked:block absolute top-1/2 -translate-y-1/2", t17, {
      "left-3s w-2s h-2s": t18,
      "left-s w-2s h-2s": t19,
      "left-3xs w-s h-s": t20,
      "right-3s w-2s h-2s": t21,
      "right-s w-2s h-2s": t22,
      "right-3xs w-s h-s": t23,
      "text-primary-800": t24,
      "text-neutral-150": disabled
    });
    $[28] = disabled;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
    $[32] = t20;
    $[33] = t21;
    $[34] = t22;
    $[35] = t23;
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== isCheckbox || $[39] !== size) {
    t26 = isCheckbox ? <span className="flex h-full w-full items-center justify-center text-neutral-0"><Icon icon={Check} size={size === "xs" ? 12 : 14} /></span> : <span className="block rounded-full w-full h-full bg-current border-[3px] border-neutral-0" />;
    $[38] = isCheckbox;
    $[39] = size;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t25 || $[42] !== t26) {
    t27 = <span className={t25}>{t26}</span>;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  const t28 = !icon && size === "md";
  const t29 = !icon && size === "sm";
  const t30 = !icon && size === "xs";
  const t31 = icon && size === "md";
  const t32 = icon && size === "sm";
  const t33 = icon && size === "xs";
  const t34 = !disabled;
  let t35;
  if ($[44] !== disabled || $[45] !== t28 || $[46] !== t29 || $[47] !== t30 || $[48] !== t31 || $[49] !== t32 || $[50] !== t33 || $[51] !== t34) {
    t35 = clsx("bg-neutral-0 w-full  border border-neutral-50 rounded-s peer-focus-visible:ring-2 ring-primary-800 ring-offset-2  flex gap-s items-center peer-checked:border-primary-800 hover:bg-neutral-12 transition-colors peer-checked:shadow-4 peer-checked:bg-primary-25", {
      "pl-xl pr-3s py-[11px]": t28,
      "pl-3m pr-2s py-[11px]": t29,
      "pl-2m pr-3xs py-[7px]": t30,
      "pr-xl pl-3s py-[11px]": t31,
      "pr-3m pl-2s py-[11px]": t32,
      "pr-2m pl-3xs py-[7px]": t33,
      "group-hover/switch:border-primary-800 group-active/switch:border-primary-875 peer-checked/switch:border-primary-800": t34,
      "bg-neutral-12": disabled
    });
    $[44] = disabled;
    $[45] = t28;
    $[46] = t29;
    $[47] = t30;
    $[48] = t31;
    $[49] = t32;
    $[50] = t33;
    $[51] = t34;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  let t36;
  if ($[53] !== icon || $[54] !== size) {
    t36 = icon && <span className={clsx("flex-none flex items-center justify-center text-neutral-675", {
      "h-3s w-3s": size === "sm",
      "h-2m w-2m": size === "md",
      "h-s w-s": size === "xs"
    })}>{icon}</span>;
    $[53] = icon;
    $[54] = size;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  const t37 = size === "md";
  const t38 = size === "sm";
  const t39 = size === "xs";
  let t40;
  if ($[56] !== t37 || $[57] !== t38 || $[58] !== t39) {
    t40 = clsx("flex-1 text-neutral-675 max-w-full", {
      "text-body-1": t37,
      "text-app-body-1": t38,
      "text-app-body-2": t39
    });
    $[56] = t37;
    $[57] = t38;
    $[58] = t39;
    $[59] = t40;
  } else {
    t40 = $[59];
  }
  let t41;
  if ($[60] !== children || $[61] !== t40) {
    t41 = <span className={t40}>{children}</span>;
    $[60] = children;
    $[61] = t40;
    $[62] = t41;
  } else {
    t41 = $[62];
  }
  let t42;
  if ($[63] !== t35 || $[64] !== t36 || $[65] !== t41) {
    t42 = <span className={t35}>{t36}{t41}</span>;
    $[63] = t35;
    $[64] = t36;
    $[65] = t41;
    $[66] = t42;
  } else {
    t42 = $[66];
  }
  let t43;
  if ($[67] !== t16 || $[68] !== t27 || $[69] !== t3 || $[70] !== t42 || $[71] !== t5 || $[72] !== t6) {
    t43 = <label data-testid={t3} className={t5}>{t6}{t16}{t27}{t42}</label>;
    $[67] = t16;
    $[68] = t27;
    $[69] = t3;
    $[70] = t42;
    $[71] = t5;
    $[72] = t6;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  return t43;
});
export default RadioCard;